import type { RefObject } from "react";
import { useEffect } from "react";
import type { ManagedDisplayObject } from "../types";
import { useScene } from "./useScene";

export interface ConstantScreenSizeOptions {
    allowShrinkToFit?: boolean;
    minScale?: number;
    maxScale?: number;
}

export function useConstantScreenSize(
    ref: RefObject<ManagedDisplayObject | null>,
    {
        minScale,
        maxScale,
        allowShrinkToFit = false,
    }: ConstantScreenSizeOptions = {},
): void {
    const { viewportEffectsManager } = useScene();

    useEffect(() => {
        if (!ref.current?.scale) return;

        return viewportEffectsManager.registerConstantScreenSize(
            ref,
            minScale,
            maxScale,
            allowShrinkToFit,
        );
    }, [allowShrinkToFit, maxScale, minScale, ref, viewportEffectsManager]);
}
